
//Principais
import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { AtribuicaoLoginSed, UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
//Métodos
import { Polo } from "src/app/shared/models/polo/Polo";
import { AvaliacaoVisitaPsicologo } from "src/app/shared/models/psicologo/AvaliacaoVisitaPsicologo";
import { Psicologo } from "src/app/shared/models/psicologo/Psicologo";
//Serviços
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

@Component({
  selector: 'app-availacao-visita-fiscal',
  templateUrl: './availacao-visita-fiscal.component.html',
  styleUrls: ['./availacao-visita-fiscal.component.scss'],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports]
})
export class AvailacaoVisitaFiscalComponent implements OnInit {
  //Injeções
  private spinnerService = inject(NgxSpinnerService);
  private toastr = inject(ToastrService)
  private authService = inject(AuthService)
  private psicologoService = inject(PsicologoService)
  private ConvivaErrors = inject(ConvivaErrorHandlingService)
  private router = inject(Router)
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;
  public polos: Polo[] = [];
  public lstPsicologos: Psicologo[] = [];
  public lstAvaliacaoFiscal: AvaliacaoVisitaPsicologo[] = [];
  public showPesquisa: boolean;

  public titleExport = 'Avaliação de Visita Fiscal';
  public colunasGrid = [
    { title: 'Código', field: 'codigoAtividadePsicologo', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Nome Diretoria', field: 'nomeDiretoria', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Nome Escola', field: 'nomeEscola', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Escola Origem', field: 'deslocamentoEscolaOrigem', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Nome Psicologo', field: 'nomePsicologo', width: 250, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Data Visita', field: 'dataVisita', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "datetime", formatterParams: { inputFormat: "iso", outputFormat: "dd/MM/yyyy", }  },
    { title: 'Tipo Ação', field: 'descricaoTipoAcao', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Tempo Ação Geral', field: 'tempoAcaoGeral', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Ocorrência Agendada', field: 'ocorrenciaAgendada', width: 250, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Atividade Realizada', field: 'descricaoAtividadeRealizada', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Validação Fiscal', field: 'descricaoValidacaoFiscal', hozAlign: "center", headerHozAlign: "center" },
    // { title: 'Validação Diretor', field: 'descricaoValidacaoDiretor', hozAlign: "center",headerHozAlign:"center"  },
    // { title: 'Envolvidos', field: 'envolvidos', hozAlign: "center",headerHozAlign:"center"  },
    {
      title: 'Visualizar', field: 'visualizar', hozAlign: "center", formatter: function (cell: any, formatterParams: any, onRendered: any) {
        return `<div style='display:inline-flex;gap:0.4em;'> <i class='fa fa-eye'  aria-hidden='true'></i>`;
      }, headerHozAlign: "center", cellClick: (e: any, cell: any) => this.OnClickAcao(e, cell)
    }
  ];

  public formAvaliacao!: FormGroup;
  public get form() { return this.formAvaliacao.controls; }
  public submitted: boolean;
  // public tiraObligatoriedade: boolean;
  get PodePesquisarSemFiltroEscola(): boolean {
    return (this.userLogado?.codigoPerfil == Perfil.GestorConviva ||
      this.userLogado?.codigoPerfil == Perfil.FiscalPsicologo ||
      this.userLogado?.codigoPerfil == Perfil.GestorCGRH)
  }

  constructor(

  ) {
    this.userLogado = this.authService.getUser();
    if (this.userLogado != null) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  public async ngOnInit(): Promise<void> {
    this.formAvaliacao = new FormGroup({
      codigoPolo: new FormControl(null, [Validators.required]),
      codigoPsicologo: new FormControl(null)
    });
    if (this.atribuicoesLogin.NumeroComportamento == 1) {
      await this.getPolosAdmin();
    }

    if (this.atribuicoesLogin.NumeroComportamento == 2) {
      await this.getPolosPerfilDiretor();
    }
    // await this.Visualizar();
    //  await this.getPsicologos();

  }

  public async OnChangePolo() {

    const codigoPolo = this.formAvaliacao.get('codigoPolo')?.value;
    if (this.userLogado !== null) {
      this.userLogado.codigoPolo = codigoPolo == null ? 0 : codigoPolo;
      this.authService.setUser(this.userLogado);
    }
    if (codigoPolo != null) {
      await this.getPsicologos();
    } else {
      this.zerarPsicologos();
    }
  }

  public zerarPsicologos() {
    this.lstPsicologos = [];
    this.formAvaliacao.get('codigoPsicologo')?.patchValue(null);
  }

  public async Visualizar() {

    this.submitted = true;
    this.spinnerService.show();

    const codigoPolo = this.formAvaliacao.get('codigoPolo')!.value
    const codigoPsicologo = this.formAvaliacao.get('codigoPsicologo')!.value == null ? 0 : this.formAvaliacao.get('codigoPsicologo')!.value;

    if (this.formAvaliacao.invalid) {
      this.showPesquisa = false;
      this.toastr.warning("Polo é um campo obrigatório!");
      this.spinnerService.hide();
      return;
    }

    if (!this.form.codigoPsicologo.value && !this.PodePesquisarSemFiltroEscola) {
      this.showPesquisa = false;
      this.toastr.warning("Psicólogo é um campo obrigatório!");
      this.spinnerService.hide();
      return;
    }

    const response = await lastValueFrom(this.psicologoService.getAvaliacaoFiscal(codigoPolo, codigoPsicologo))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.showPesquisa = true;
    this.lstAvaliacaoFiscal = response.data;
  }

  public async getPolosAdmin() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos())
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.polos = response.data;
    this.spinnerService.hide();
    if (this.userLogado?.codigoPolo != 0) {
      this.ativaPolo();
      await this.OnChangePolo();
    }
    this.spinnerService.hide();
  }
  public async getPolosPerfilDiretor() {

    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos(this.userLogado?.DadosUsuario[0].CodigoDiretoria)).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.polos = response.data;
    this.form.codigoPolo.setValue(this.polos[0].codigoPolo);
    this.form.codigoPolo.disable();
    await this.OnChangePolo();
    this.spinnerService.hide();

  }


  public ativaPolo() {
    if (this.userLogado?.codigoPolo != undefined)
      this.formAvaliacao.get('codigoPolo')?.setValue(this.userLogado?.codigoPolo);
    if (this.userLogado !== null && this.userLogado)
      this.authService.setUser(this.userLogado);
  }

  public async onChangePsicologo() {
    const codigoPsicologo = this.formAvaliacao.get('codigoPsicologo')?.value;
    if (this.userLogado !== null && codigoPsicologo != null) {
      this.userLogado.codigoPsicologo = codigoPsicologo == null ? 0 : codigoPsicologo;
      this.authService.setUser(this.userLogado);
    }
  }

  public async getPsicologos() {
    this.spinnerService.show();

    if (this.userLogado?.codigoPolo) {
      this.zerarPsicologos();
      const response = await lastValueFrom(this.psicologoService.getPsicologosPorPolo(this.userLogado!.codigoPolo))
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.lstPsicologos = response.data;
      this.form.codigoPsicologo.enable();
      this.ativaPsicologo();
      this.spinnerService.hide();
    }
    if (this.userLogado !== null) {
      this.userLogado.codigoPsicologo = this.userLogado.codigoPsicologo == null ? 0 : this.userLogado.codigoPsicologo;
      this.authService.setUser(this.userLogado);
    }
  }

  public ativaPsicologo() {
    const psicologo = this.lstPsicologos.filter(s => s.codigoPsicologo == this.userLogado?.codigoPsicologo);
    if (this.userLogado?.codigoPsicologo && this.userLogado?.codigoPsicologo > 0 && psicologo.length > 0) {
      this.formAvaliacao.get('codigoPsicologo')?.setValue(this.userLogado?.codigoPsicologo);
    }
    const polo = this.polos.filter(s => s.codigoPolo == this.userLogado?.codigoPolo);
    if (this.userLogado?.codigoPolo && this.userLogado?.codigoPolo > 0 && polo.length > 0) {
      this.formAvaliacao.get('codigoPolo')?.setValue(this.userLogado?.codigoPolo);
    }
  }

  private OnClickAcao(e: any, cell: any) {
    // Evento de click na célula para capturar os botões
    const row = cell.getRow().getData(); // Dados da linha
    const target = e.target; // Elemento clicado
    const codigoAtividadePsicologo = row.codigoAtividadePsicologo;
    if (target.classList.contains('fa-eye')) {
      this.router.navigate(['/visualizar-atividade-psicologo/' + codigoAtividadePsicologo]);
    }
  }

}
